import { TextField } from "@mui/material";
import NewCoachProps from "../interface/newCoachProps";
import SearchUserProps from "../interface/searchUserProps";

const RenderTeamsLink = ({
  newCoach,
  setNewCoach,
  searchUser,
}: {
  newCoach: NewCoachProps;
  setNewCoach: React.Dispatch<React.SetStateAction<NewCoachProps>>;
  searchUser: SearchUserProps;
}): React.JSX.Element => {
  return (
    <TextField
      disabled={!searchUser.selectedParticipant}
      multiline
      color="success"
      error={newCoach.teamsLink.length <= 0}
      helperText={newCoach.teamsLink.length > 0 ? "" : "Teams-Link fehlt"}
      sx={{
        "& .MuiInputBase-root": {
          color:
            newCoach.teamsLink.length > 0
              ? (theme) => theme.palette.success.main
              : (theme) => theme.palette.error.main,
        },
      }}
      required
      fullWidth
      type="text"
      id="teams-link-input"
      label="Teams-Link"
      variant="outlined"
      value={newCoach.teamsLink}
      onChange={(e) =>
        setNewCoach({
          ...newCoach,
          teamsLink: e.target.value,
        })
      }
    />
  );
};

export default RenderTeamsLink;
